import { useMemo } from "react";
import {
  isDepartsAtField,
  NUM_FLOPPTIONS_BTN_MODAL__COLDEF,
  NUM_PASSENGERS__COLDEF,
  OG_TARGET_FARE_COLDEF,
  ONEWAY__ARRIVES_AT,
  ONEWAY__CARRIER_0,
  ONEWAY__CARRIER_1,
  ONEWAY__CARRIER_2,
  ONEWAY__DEPARTS_AT,
  ONEWAY__DEST,
  ONEWAY__DURATION,
  ONEWAY__FLIGHTNO_0,
  ONEWAY__FLIGHTNO_1,
  ONEWAY__FLIGHTNO_2,
  ONEWAY__ORIG,
  ONEWAY__PINNED_LEG__COLDEF,
  ONEWAY__STOP_0,
  ONEWAY__STOP_1,
  ONEWAY__STOP_DURATION_0,
  ONEWAY__STOP_DURATION_1,
  PINNED_GROUP_NUMBER__COLDEF,
  PINNED_TOURCENTER_NUMBER__COLDEF,
  PLANNER__COLDEF,
  REPORT_ACTION_BTN_COLDEF,
  ROUNDTRIP_F1__ARRIVES_AT,
  ROUNDTRIP_F1__CARRIER_0,
  ROUNDTRIP_F1__CARRIER_1,
  ROUNDTRIP_F1__CARRIER_2,
  ROUNDTRIP_F1__DEPARTS_AT,
  ROUNDTRIP_F1__DEST,
  ROUNDTRIP_F1__DURATION,
  ROUNDTRIP_F1__FLIGHTNO_0,
  ROUNDTRIP_F1__FLIGHTNO_1,
  ROUNDTRIP_F1__FLIGHTNO_2,
  ROUNDTRIP_F1__ORIG,
  ROUNDTRIP_F1__STOP_0,
  ROUNDTRIP_F1__STOP_1,
  ROUNDTRIP_F1__STOP_DURATION_0,
  ROUNDTRIP_F1__STOP_DURATION_1,
  ROUNDTRIP_F2__ARRIVES_AT,
  ROUNDTRIP_F2__CARRIER_0,
  ROUNDTRIP_F2__CARRIER_1,
  ROUNDTRIP_F2__CARRIER_2,
  ROUNDTRIP_F2__DEST,
  ROUNDTRIP_F2__DURATION,
  ROUNDTRIP_F2__FLIGHTNO_0,
  ROUNDTRIP_F2__FLIGHTNO_1,
  ROUNDTRIP_F2__FLIGHTNO_2,
  ROUNDTRIP_F2__ORIG,
  ROUNDTRIP_F2__STOP_0,
  ROUNDTRIP_F2__STOP_1,
  ROUNDTRIP_F2__STOP_DURATION_0,
  ROUNDTRIP_F2__STOP_DURATION_1,
  XCA__SALES__COLDEF,
} from "./common-coldefs";
import { useAppMode, useItinMode } from "../store/model-misc";
import {
  filterToColdefsForAppmode,
  filterToColdefsForItinmode,
  maybeAddUserTimezone,
} from "./saxecap-dev-coldefs";
import { useUserTimezone } from "./data-refresh-stats";
import _ from "lodash";

// function countUnique(iterable) {
//     return new Set(iterable).size;
// }

export function useColDefs(tableName) {
  //rowData) {
  const userTz = useUserTimezone();
  const appMode = useAppMode();
  const itinMode = useItinMode();
  // console.log({ appMode });
  return useMemo(() => {
    let colDefs = [...DEFAULT_COL_DEFS];
    if (tableName === "opportunities") {
      colDefs = [
        ...colDefs.filter(({ field }) => isDepartsAtField(field)),
        PINNED_GROUP_NUMBER__COLDEF,
        PINNED_TOURCENTER_NUMBER__COLDEF,
        ONEWAY__PINNED_LEG__COLDEF,
        PLANNER__COLDEF,
        TCA__COLDEF,
        XCA__SALES__COLDEF,
        ...colDefs.filter(
          ({ field }) => field !== "action" && !isDepartsAtField(field)
        ),
        NUM_FLOPPTIONS_BTN_MODAL__COLDEF,
        ...colDefs.filter(({ field }) => field === "action"),
      ];

      if (appMode === "xca" && itinMode === "roundtrip") {
        colDefs = colDefs.map((cd) => {
          const hide = XCA_OPPS__VISIBLE__IDS.includes(coldef2id(cd))
            ? undefined
            : true;
          return { ...cd, hide };
        });
        colDefs = _.sortBy(colDefs, (cd) => {
          const colid = coldef2id(cd);
          const colidx = XCA_OPPS__VISIBLE__IDS.indexOf(colid);
          if (colidx >= 0) {
            return colidx;
          } else {
            return 10000;
          }
        });
      }
    } else if (tableName === "suspends") {
      colDefs = [
        ...colDefs.filter(({ field }) => isDepartsAtField(field)),
        PINNED_GROUP_NUMBER__COLDEF,
        PINNED_TOURCENTER_NUMBER__COLDEF,
        ONEWAY__PINNED_LEG__COLDEF,
        {
          headerName: "Submitter",
          field: "submitted_by",
          type: "categoryColumn",
          valueFormatter: ({ value }) => value.split("@")[0],
        },
        {
          headerName: "Submitted",
          field: "submitted_at",
          type: "timestampColumn",
          __timezone: "auto",
        },
        {
          headerName: "Notes",
          field: "notes",
          type: "textColumn",
        },
        ...colDefs.filter(
          ({ field }) => field !== "action" && !isDepartsAtField(field)
        ),
        PLANNER__COLDEF,
        ...colDefs.filter(({ field }) => field === "action"),
      ];
    }
    const appModeFilter = (cd) => filterToColdefsForAppmode(cd, appMode);
    const itinModeFilter = (cd) => filterToColdefsForItinmode(cd, itinMode);
    colDefs = colDefs.filter(appModeFilter).filter(itinModeFilter);
    // const numUniquePlannerCodes = rowData
    //   ? countUnique(rowData.map((r) => r[PLANNER__COLDEF.field]))
    //   : 0;
    // if (numUniquePlannerCodes === 1) {
    //   colDefs = colDefs.filter((cd) => cd.field !== PLANNER__COLDEF.field);
    // }
    return colDefs.map((cd) => maybeAddUserTimezone(cd, userTz));
  }, [tableName, appMode, itinMode, userTz]);
}

const TOTAL_SAVINGS__COLDEF = {
  headerName: "Total Savings",
  field: "Total Savings",
  type: "moneyColumn",
};
const CURR_AVG_FARE__COLDEF = {
  headerName: "Current Avg Fare",
  field: "Current Avg Fare",
  type: "moneyColumn",
};
const OPP_FARE__COLDEF = {
  headerName: "Opp Fare",
  field: "fare",
  type: "moneyColumn",
};
const FARE_SAVINGS__COLDEF = {
  headerName: "Fare Savings",
  field: "Fare Savings",
  type: "moneyColumn",
};
const PCT_FARE_SAVINGS__COLDEF = {
  headerName: "% Savings",
  field: "% Fare Savings",
  type: "floatColumn",
};
const SITE_ID__COLDEF = {
  headerName: "SiteID",
  field: "[Book] SiteID",
  type: "categoryColumn",
  __appMode: "xca",
};
const TCA__COLDEF = {
  headerName: "TCA",
  field: "[Book] TCA",
  type: "categoryColumn",
  __appMode: "xca",
};

const XCA_ROUNDTRIP__OPPS__VISIBLE__COLDEFS = [
  PINNED_TOURCENTER_NUMBER__COLDEF,
  PLANNER__COLDEF,
  ROUNDTRIP_F1__CARRIER_0,
  NUM_PASSENGERS__COLDEF,
  TOTAL_SAVINGS__COLDEF,
  CURR_AVG_FARE__COLDEF,
  OPP_FARE__COLDEF,
  FARE_SAVINGS__COLDEF,
  PCT_FARE_SAVINGS__COLDEF,
  SITE_ID__COLDEF,
  TCA__COLDEF,
  NUM_FLOPPTIONS_BTN_MODAL__COLDEF,
  REPORT_ACTION_BTN_COLDEF,
];

export function coldef2id(coldef) {
  return `${coldef.headerName}|%^&${coldef.field}`;
}

export const XCA_OPPS__VISIBLE__IDS = XCA_ROUNDTRIP__OPPS__VISIBLE__COLDEFS.map(
  coldef2id
);

const DEFAULT_COL_DEFS = [
  { ...ONEWAY__DEPARTS_AT, pinned: "left" },
  { ...ROUNDTRIP_F1__DEPARTS_AT, pinned: "left" },
  TOTAL_SAVINGS__COLDEF,

  ONEWAY__CARRIER_0,
  ROUNDTRIP_F1__CARRIER_0,
  ROUNDTRIP_F2__CARRIER_0,

  ONEWAY__FLIGHTNO_0,
  ROUNDTRIP_F1__FLIGHTNO_0,
  ROUNDTRIP_F2__FLIGHTNO_0,
  OPP_FARE__COLDEF,
  NUM_PASSENGERS__COLDEF,

  ONEWAY__ORIG,
  ROUNDTRIP_F1__ORIG,
  ROUNDTRIP_F2__ORIG,

  ONEWAY__DEST,
  ROUNDTRIP_F1__DEST,
  ROUNDTRIP_F2__DEST,

  ONEWAY__STOP_0,
  ROUNDTRIP_F1__STOP_0,
  ROUNDTRIP_F2__STOP_0,

  ONEWAY__STOP_1,
  ROUNDTRIP_F1__STOP_1,
  ROUNDTRIP_F2__STOP_1,

  OG_TARGET_FARE_COLDEF,
  CURR_AVG_FARE__COLDEF,
  FARE_SAVINGS__COLDEF,
  {
    headerName: "Type",
    field: "Budget Tour Type",
    type: "categoryColumn",
    __appMode: "dvy",
  },

  ONEWAY__ARRIVES_AT,
  ROUNDTRIP_F1__ARRIVES_AT,
  ROUNDTRIP_F2__ARRIVES_AT,

  ONEWAY__DURATION,
  ROUNDTRIP_F1__DURATION,
  ROUNDTRIP_F2__DURATION,

  ONEWAY__STOP_DURATION_0,
  ROUNDTRIP_F1__STOP_DURATION_0,
  ROUNDTRIP_F2__STOP_DURATION_0,

  ONEWAY__CARRIER_1,
  ROUNDTRIP_F1__CARRIER_1,
  ROUNDTRIP_F2__CARRIER_1,

  ONEWAY__FLIGHTNO_1,
  ROUNDTRIP_F1__FLIGHTNO_1,
  ROUNDTRIP_F2__FLIGHTNO_1,

  ONEWAY__STOP_DURATION_1,
  ROUNDTRIP_F1__STOP_DURATION_1,
  ROUNDTRIP_F2__STOP_DURATION_1,

  ONEWAY__CARRIER_2,
  ROUNDTRIP_F1__CARRIER_2,
  ROUNDTRIP_F2__CARRIER_2,

  ONEWAY__FLIGHTNO_2,
  ROUNDTRIP_F1__FLIGHTNO_2,
  ROUNDTRIP_F2__FLIGHTNO_2,

  {
    headerName: "Group#",
    field: "[Book] Group#",
    type: "textColumn",
    __appMode: "dvy",
  },
  {
    headerName: "Tour#",
    field: "[Book] Tour#",
    type: "integerColumn",
    __appMode: "dvy",
  },
  {
    headerName: "School",
    field: "[Book] School",
    type: "textColumn",
    __appMode: "dvy",
  },
  {
    headerName: "A/P",
    field: "A/P",
    type: "categoryColumn",
    __appMode: "dvy",
  },
  SITE_ID__COLDEF,
  {
    headerName: "RES",
    field: "[Book] RES",
    type: "integerColumn",
    __appMode: "xca",
  },
  {
    headerName: "PAX",
    field: "[Book] PAX",
    type: "integerColumn",
    __appMode: "xca",
  },
  {
    headerName: "LO",
    field: "[Book] LO",
    type: "integerColumn",
    __appMode: "xca",
  },
  {
    headerName: "OriginGTW",
    field: "[Book] OriginGTW",
    type: "categoryColumn",
    __appMode: "xca",
  },
  {
    headerName: "ArrivalGTW",
    field: "[Book] ArrivalGTW",
    type: "categoryColumn",
    __appMode: "xca",
  },
  {
    headerName: "ReturnGTW",
    field: "[Book] ReturnGTW",
    type: "categoryColumn",
    __appMode: "xca",
  },
  PCT_FARE_SAVINGS__COLDEF,
  REPORT_ACTION_BTN_COLDEF,
];
